import { makeAutoObservable } from 'mobx'

import type { Point, TimeStamp } from '../../types'
import type { HandwrittenNoteItem } from './HandwrittenNoteData'

export interface HandwrittenNoteTextData {
  id: number
  x: number
  y: number
  text: string
  fontSize: number
  color: string
  width: number
  height: number
  createdAt: TimeStamp
}

export default class HandwrittenNoteTextItem implements HandwrittenNoteItem {
  id: number
  isDeleted = false
  text = ''
  position: Point
  fontSize: number
  color: string
  width: number
  height: number
  createdAt: TimeStamp

  constructor(
    id: number,
    position: Point,
    fontSize: number,
    color: string,
    createdAt: TimeStamp,
    text = '',
    width = 210,
    height = 60,
  ) {
    this.id = id
    this.position = position
    this.fontSize = fontSize
    this.color = color
    this.text = text
    this.width = width
    this.height = height
    this.createdAt = createdAt
    makeAutoObservable(this)
  }

  setText(value: string) {
    this.text = value
  }

  setPosition(value: Point) {
    this.position = value
  }

  setFontSize(fontSize: number) {
    this.fontSize = fontSize
  }

  setColor(color: string) {
    this.color = color
  }

  setIsDeleted(value: boolean) {
    this.isDeleted = value
  }

  setTextboxSize(width: number, height: number) {
    this.width = width
    this.height = height
  }

  undo() {
    this.setIsDeleted(true)
  }

  redo() {
    this.setIsDeleted(false)
  }

  toData(): HandwrittenNoteTextData {
    return {
      id: this.id,
      x: this.position.x,
      y: this.position.y,
      text: this.text,
      fontSize: this.fontSize,
      color: this.color,
      width: this.width,
      height: this.height,
      createdAt: this.createdAt,
    }
  }

  static fromData(data: HandwrittenNoteTextData): HandwrittenNoteTextItem {
    return new HandwrittenNoteTextItem(
      data.id,
      { x: data.x, y: data.y },
      data.fontSize,
      data.color,
      data.createdAt,
      data.text,
      data.width,
      data.height,
    )
  }
}
